import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "w-lg-500px bg-secondary rounded shadow-sm p-10 p-lg-15 mx-auto",
  style: {"--bs-bg-opacity":"0.2"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-left mb-7" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold text-dark mb-3" }, "Iniciar Sesión"),
  /*#__PURE__*/_createElementVNode("p", { class: "fs-base" }, "Ingresa tus credenciales para iniciar")
], -1)
const _hoisted_3 = { class: "fv-row mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base fw-bold text-dark" }, "Correo electrónico", -1)
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-at text-white fs-4" })
  ])
], -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base fw-bold text-dark fs-6 mb-0" }, "Contraseña")
], -1)
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_13 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_14 = {
  key: 0,
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_15 = {
  key: 1,
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base fw-bold" }, " Iniciar sesión ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base fw-bold" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, {
        class: "form w-100",
        id: "kt_login_signin_form",
        onSubmit: _ctx.onSubmitLogin,
        "validation-schema": _ctx.login
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg fs-base form-control-solid ps-13",
                type: "email",
                name: "email",
                autocomplete: "off",
                placeholder: "Correo",
                style: {"background":"none","border":"1px solid gray"}
              }),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ErrorMessage, { name: "email" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid fs-base ps-12",
                type: _ctx.typePassword ? 'password' : 'text',
                name: "password",
                autocomplete: "off",
                placeholder: "••••••",
                style: {"background":"none","border":"1px solid gray"}
              }, null, 8, ["type"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Contraseña-1.svg" })
                ])
              ]),
              _createElementVNode("div", {
                class: "position-absolute translate-middle-y top-50 end-0 ms-3",
                style: {"right":"10px !important"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeType && _ctx.changeType(...args)))
              }, [
                (_ctx.typePassword)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/eye.svg" })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.typePassword)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/eye-slash.svg" })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_ErrorMessage, { name: "password" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", _hoisted_19, _hoisted_22, 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_router_link, {
      to: "/forgot-password",
      class: "link-primary fs-sm mt-5 text-white"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" ¿Olvidaste tu contraseña? ")
      ]),
      _: 1
    })
  ], 64))
}